import HttpService from 'services/HttpService';

export default class NotificationService {
    constructor() {
        this._http = new HttpService();
        this.userNotificationIds = {};
        this.loaded = false;
        this.initNotificationList();
    }

    initNotificationList() {
        //No notification list for anon users
        if (!CBS.Registry.user.sub_status) return;

        const url = `/user-profile/xhr/content-preference-ids/?nocache=${new Date().getTime()}`;

        this._http
            .doGet(url)
            .then(({ data }) => {
                if (Array.isArray(data?.preferences)) {
                    this.userNotificationIds = Object.fromEntries(
                        data.preferences.map((value) => [value, true]),
                    );
                    this.loaded = true;
                }
            })
            .catch((e) => {
                console.error('Error fetching notificationList IDs:', e.message);
            });
    }

    isContentInNotificationList(id) {
        if (Object.keys(this.userNotificationIds).length === 0) return false;
        return id in this.userNotificationIds;
    }

    addContentToNotificationList(id, addUrl) {
        this.userNotificationIds[id] = true;

        return this._http.doGet(addUrl);
    }

    removeContentFromNotificationList(id, removeUrl) {
        if (id in this.userNotificationIds) {
            delete this.userNotificationIds[id];
        }

        return this._http.doGet(removeUrl);
    }
}
